module.exports = __webpack_public_path__ + "static/media/Mastercard.561522f4.jpg";